import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
    useIsTablet,
    useIsHuge,
    useIsSmaller1400
} from "../../lib/hooks/mediaQueries";

import { Headline } from "../../components/Headline";
import { ImageWithGrid } from "../../components/Image";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { Tagline } from "../../components/Tagline/Tagline";
import * as styles from "./mediaForContact.module.less";
import { useMediaQuery } from "react-responsive";
import GeneralPageContext from "../../templates/GeneralPageContext";

function MediaForContact({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        subheadline,
        downloadLink,
        image,
        background
    },
    type
}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);
    const isSmaller1400 = useIsSmaller1400();
    const isHuge = useIsHuge();
    const isMobile = useIsTablet();
    const isMin1199 = useMediaQuery({ query: "(min-width: 1199px" });

    // prettier-ignore
    const gridSize = showAnchorNavigation && isMin1199 ? isSmaller1400 ? "M" : "L" : (isMobile ? "S" : (isSmaller1400 ? "M" : (isHuge ? "XL" : "L")));

    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);




    return (
        <SectionContainer
            sectionId={anker}
            sectionClass={styles.mediaForContactContentSection}
            containerClass={styles.mediaForContactContainer}
            background={background}
        >
            <div className={styles.contentContainer}>
                <div className={styles.leftContainer}>
                    {tagline && <Tagline>{tagline}</Tagline>}

                    {headline && (
                        <Headline semanticOfHeadline={semanticOfHeadline}>
                            {headline}
                        </Headline>
                    )}

                    {subheadline?.value && (
                        <StructuredTextRenderer
                            className={styles.subheadline}
                            data={subheadline}
                            contentElementType={type}
                        />
                    )}

                    {(downloadLink?.value && hasMounted) && (
                        <StructuredTextRenderer
                            itemLinkType="cta"
                            itemLinkIcon="download"
                            itemLinkIconPosition="left"
                            data={downloadLink}
                            className={styles.button}
                        />
                    )}
                </div>

                {image && (
                    <div className={styles.rightContainer}>
                        <ImageWithGrid image={image} gridSize={gridSize} />
                    </div>
                )}
            </div>
        </SectionContainer>
    );
}

MediaForContact.propTypes = {
    type: PropTypes.string,
    data: PropTypes.shape({
        anker: PropTypes.string,
        tagline: PropTypes.string,
        headline: PropTypes.string,
        semanticOfHeadline: PropTypes.string.isRequired,
        subheadline: PropTypes.object.isRequired,
        downloadLink: PropTypes.object.isRequired,
        image: PropTypes.object.isRequired,
        background: PropTypes.string.isRequired
    }).isRequired
};

export { MediaForContact };
